import { DocumentType, TravellerDocumentFields } from './types';

export const CisCountries = ['AM', 'AZ', 'BY', 'MD', 'TJ', 'KZ', 'KG', 'UZ', 'RU'];

export const DocumentFields = [
	TravellerDocumentFields.FirstName,
	TravellerDocumentFields.LastName,
	TravellerDocumentFields.MiddleName,
	TravellerDocumentFields.DocNumber,
	TravellerDocumentFields.DocExpiryDate,
	TravellerDocumentFields.DocType,
	TravellerDocumentFields.Citizenship
];

export const initialTravellerDocument: DocumentType = {
	firstName: '',
	lastName: '',
	middleName: '',
	docType: null,
	docNumber: '',
	docExpiryDate: '',
	citizenship: ''
};
